/**
 * MODULE: _shared/frontend/lib/frontend/mobile/mobilePushNavigation.ts
 * PURPOSE: Parse mobile push payloads and resolve deep-link navigation (Sprint 11 mobile signals).
 * DEPENDENCIES: none (pure helpers)
 * PUBLIC_API: MOBILE_PUSH_TAP_EVENT, resolvePushDeepLink, dispatchMobilePushTap, isSalesSignalPush
 * SIDE_EFFECTS: dispatchMobilePushTap emits window CustomEvent
 * AGENT_SAFETY: SAFE
 * RECENT: Sprint 11 [2.2.1082] — sales_signal tap → /activity?filter=signals
 */

export const MOBILE_PUSH_TAP_EVENT = 'brazn:mobile-push-tap';
export const SALES_SIGNAL_PUSH_TYPE = 'sales_signal';
export const SALES_SIGNAL_DEEP_LINK = '/activity?filter=signals';

export type MobilePushTapPayload = {
 type?: string;
 event_type?: string;
 deep_link?: string;
 payload?: {
 type?: string;
 deep_link?: string;
 signal_count?: number;
 deal_id?: string | null;
 signal_ids?: string[];
 };
};

function readPushType(payload: MobilePushTapPayload): string {
 return (
 payload.type ??
 payload.event_type ??
 payload.payload?.type ??
 ''
 ).trim();
}

/** True when the push should open the Activity feed Signals tab. */
export function isSalesSignalPush(payload: MobilePushTapPayload): boolean {
 return readPushType(payload) === SALES_SIGNAL_PUSH_TYPE;
}

/** Resolve in-app path from a push tap payload; null when unknown or unsupported. */
export function resolvePushDeepLink(payload: MobilePushTapPayload): string | null {
 const explicit =
 payload.deep_link?.trim() || payload.payload?.deep_link?.trim();
 if (explicit?.startsWith('/')) {
 return explicit;
 }
 if (isSalesSignalPush(payload)) {
 return SALES_SIGNAL_DEEP_LINK;
 }
 return null;
}

/** Bridge for service worker / native shell → React router (also used in tests). */
export function dispatchMobilePushTap(payload: MobilePushTapPayload): void {
 if (typeof window === 'undefined') return;
 window.dispatchEvent(
 new CustomEvent<MobilePushTapPayload>(MOBILE_PUSH_TAP_EVENT, { detail: payload })
 );
}
